import { ContentContainer, Row, Col } from '@snsw-gel/react';
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { getValidationStatus } from '../../../services/api-services';

const ProfileConnectLanding = () => {
    const history = useHistory();

    useEffect(() => {
        (async () => {
            const flowType = localStorage.getItem('soFlow');
            getValidationStatus(flowType).then(response => {
                const routeName = flowType == 'apply' ? 'selectedCard' : '/link/validateCard';
                localStorage.removeItem('soFlow');

                if (routeName) {
                    history.push(routeName);
                }
            });
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ContentContainer>
            <Row>
                <Col span={12}>
                    Validating...
                </Col>
            </Row>
        </ContentContainer>
    );
};

export default ProfileConnectLanding;
